module.exports = __webpack_public_path__ + "images/logo-small.png?59f0574bd4abbed4572cb4ec9a36294e";